/**
 * nearby.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2018, Codrops
 * http://www.codrops.com
 */


// others
import { isSafariDesktop } from '@/scripts/utils';

/**
 * Distance between two points P1 (x1,y1) and P2 (x2,y2).
 */
export const distancePoints = (x1, y1, x2, y2) => Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));

export const NEARBY_DATA = 'NEARBY_DATA';

// from http://www.quirksmode.org/js/events_properties.html#position
export const getMousePos = (e = window.event) => {
  let posx = 0;
  let posy = 0;

  if (e.pageX || e.pageY) {
    posx = e.pageX;
    posy = e.pageY;
  } else if (e.clientX || e.clientY) {
    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }
  const scrollX = document.body.scrollLeft + document.documentElement.scrollLeft;
  const scrollY = document.body.scrollTop + document.documentElement.scrollTop;
  return {
    x: posx, y: posy, scrollX, scrollY,
  };
};

export const lineEq = (y2, y1, x2, x1, currentVal) => {
  // y = mx + b
  const m = (y2 - y1) / (x2 - x1);
  const b = y1 - m * x1;
  return m * currentVal + b;
};

export const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
export const shuffleArray = arr => arr.sort(() => Math.random() - 0.5);

class Nearby {
  constructor() {
    // this.DOM = { el };
    // this.options = options;
    //
    this.elements = {};
    this.docScrolls = { left: 0, top: 0 };
    this.mousePos = { x: 0, y: 0 };

    this.mouseMove = this.mouseMove.bind(this);
    this.scroll = this.scroll.bind(this);

    this.i = 0;
    this.init();
  }

  scroll() {
    this.setDocScrolls();
    Object.keys(this.elements).forEach((key) => {
      this.elements[key].setScrolls();
    });
  }

  mouseMove(e) {
    requestAnimationFrame(() => {
      this.setMousePos(e);
      Object.keys(this.elements).forEach((key) => {
        this.elements[key].update();
      });
    });
  }

  setDocScrolls() {
    this.docScrolls = {
      left: document.body.scrollLeft + document.documentElement.scrollLeft,
      top: document.body.scrollTop + document.documentElement.scrollTop,
    };
  }

  setMousePos(e) {
    this.mousePos = getMousePos(e);
  }

  addElement(DOM, { onProgress, notDestroy, disableForPerformance = false }) {
    const self = this;
    if (disableForPerformance && isSafariDesktop()) return;
    const element = {
      DOM,
      onProgress,
      notDestroy,
      setScrolls() {
        const elRect = this.DOM.getBoundingClientRect();
        this.elCoords = {
          x1: elRect.left + self.docScrolls.left,
          x2: elRect.width + elRect.left + self.docScrolls.left,
          y1: elRect.top + self.docScrolls.top,
          y2: elRect.height + elRect.top + self.docScrolls.top,
        };
      },
      update() {
        if (!this.elCoords) {
          return;
        }
        const closestPoint = { x: self.mousePos.x, y: self.mousePos.y };

        if (self.mousePos.x < this.elCoords.x1) {
          closestPoint.x = this.elCoords.x1;
        } else if (self.mousePos.x > this.elCoords.x2) {
          closestPoint.x = this.elCoords.x2;
        }
        if (self.mousePos.y < this.elCoords.y1) {
          closestPoint.y = this.elCoords.y1;
        } else if (self.mousePos.y > this.elCoords.y2) {
          closestPoint.y = this.elCoords.y2;
        }

        if (onProgress) {
          onProgress(distancePoints(self.mousePos.x, self.mousePos.y, closestPoint.x, closestPoint.y));
        }
      },
    };
    $(DOM).data(NEARBY_DATA, element);
    element.setScrolls();
    this.elements[this.i += 1] = element;
  }

  destroy() {
    Object.keys(this.elements).forEach((key) => {
      if (!this.elements[key].notDestroy) {
        delete this.elements[key];
      }
    });
  }

  init() {
    this.scroll();
    window.addEventListener('mousemove', this.mouseMove);
    window.addEventListener('scroll', this.scroll);
  }
}

export default new Nearby();



// WEBPACK FOOTER //
// ./scripts/utils/Nearby.js